export const EVALUATION_AGENT_API = "http://127.0.0.1:8000";